export const QUESTION_TYPE_OPTIONS = [
  { value: "single_line", label: "Tekstveld één regel" },
  { value: "multi_line", label: "Tekstveld meerdere regels" },
  { value: "radio", label: "Multiple choice" },
  { value: "star_rating", label: "Sterrenbeoordeling" },
] as const;

export const QUESTION_TYPE_LABELS: Record<string, string> = {
  single_line: "Tekstveld één regel",
  multi_line: "Tekstveld meerdere regels",
  radio: "Multiple choice",
  star_rating: "Sterrenbeoordeling",
};

export const QUESTION_TYPE_ICONS: Record<string, string> = {
  single_line: "fa-duotone fa-align-left",
  multi_line: "fa-duotone fa-align-justify",
  radio: "fa-regular fa-circle-dot",
  star_rating: "fa-regular fa-star",
};
